import { useState,useEffect } from 'react'
import { Box, Divider, Fade, FormControlLabel,Modal,Switch,TextField, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { post } from '../../utils/axios'
import Button from '../../components/Button'
import { toast } from 'react-toastify'

const Login = () => {

    const navigate = useNavigate()

    const [username,setUsername] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const [rememberMe,setRememberme] = useState(false)
    const [rules,setRules] = useState('')
    const [openModal,setOpenModal] = useState(false)

    useEffect(() => {
        const postedData = {
            key: 'rules'
        }
        post('Config/GetConfigByKey',postedData).then(({ data }) => {
            if(data.isSuccess)
                setRules(data.data.value)
        })
    },[])

    useEffect(() => {
        if(username && username.length){
            if(username.includes('۰'))
                setUsername(username.replace(/۰/g,'0'))
            if(username.includes('۱'))
                setUsername(username.replace(/۱/g,'1'))
            if(username.includes('۲'))
                setUsername(username.replace(/۲/g,'2'))
            if(username.includes('۳'))
                setUsername(username.replace(/۳/g,'3'))
            if(username.includes('۴'))
                setUsername(username.replace(/۴/g,'4'))
            if(username.includes('۵'))
                setUsername(username.replace(/۵/g,'5'))
            if(username.includes('۶'))
                setUsername(username.replace(/۶/g,'6'))
            if(username.includes('۷'))
                setUsername(username.replace(/۷/g,'7'))
            if(username.includes('۸'))
                setUsername(username.replace(/۸/g,'8'))
            if(username.includes('۹'))
                setUsername(username.replace(/۹/g,'9'))
        }
    },[username])

    const login = async e => {
        e.preventDefault()
        setIsLoading(true)
        const postedData = {
            username,
            rememberMe
        }
        const { data } = await post('User/LoginUser',postedData)
        if(data.isSuccess){
            localStorage.setItem('username',data.data.userName)
            localStorage.setItem('phone',data.data.mobile)
            toast.success('کد اعتبارسنجی به شماره همراه شما ارسال شد')
            setTimeout(() => {
                navigate('/auth/verify')
            },300)
        }else
            toast.error(data.message)
        setIsLoading(false)
    }

    const handleServicesWithoutLogin = status => {
        if(status)
            document.getElementById('services-without-login').style.display = 'unset'
        else
            document.getElementById('services-without-login').style.display = 'none'
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        maxHeight: '80%',
        overflowY: 'auto',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <form className="auth-container" onSubmit={e => login(e)}>
            <h2 className="auth-page-title">ورود</h2>
            <TextField type="tel" className="ltr-input" sx={{mb: 2}} fullWidth={true} inputProps={{maxLength: 11}} label="شماره همراه / کد ملی" variant="standard" value={username} onChange={e => setUsername(e.target.value)} onFocus={e => handleServicesWithoutLogin(false)} onBlur={e => handleServicesWithoutLogin(true)} />
            <FormControlLabel sx={{mt: 1}} control={<Switch checked={rememberMe} onChange={() => setRememberme(!rememberMe)} />} label="مرا به خاطر بسپار" />
            <p className="auth-page-accept-the-rules" style={{lineHeight: '25px',marginTop: 10,fontSize: 14,textAlign: 'justify'}}>با ورود به اپلیکیشن و استفاده از آن تمامی <span onClick={() => setOpenModal(true)} style={{color: 'purple',textDecoration: 'underline'}}>قوانین و مقررات</span> مربوطه را می پذیرم</p>
            <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!username || username.length < 10} onClick={login}>ورود</Button>
            <p className="auth-page-footer">حساب کاربری ندارید؟ <Link to="/auth/register">احراز هویت</Link></p>
            <p className="auth-page-footer"><Link to="/auth/fast-payment">پرداخت سریع (بدون ورود)</Link></p>
            <div id="services-without-login" onClick={() => navigate('/auth/scan')}>
                <i className="fal fa-qrcode"></i>
            </div>
            <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openModal}>
                    <Box sx={{...style,pb: 4}}>
                        <i className="fal fa-x close-modal-btn" onClick={() => setOpenModal(false)}></i>
                        <Typography variant="h6" component="h2" sx={{ mb: 3,fontSize: 18 }}>قوانین و مقررات</Typography>
                        <Divider />
                        <p style={{marginTop: 25,lineHeight: '25px',textAlign: 'justify'}}>{rules}</p>
                        <Button variant="outlined" color="secondary" fullWidth sx={{py: 1.5,mt: 3}} onClick={() => setOpenModal(false)}>متوجه شدم</Button>
                    </Box>
                </Fade>
            </Modal>
        </form>
    )
}

export default Login